import React, { useState } from 'react';
import { Form, Input, Select } from '@rocketseat/unform';
// import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import parseISO from 'date-fns/parseISO';

import { toast } from 'react-toastify';
import { Container, GroupHeader, Group } from './styles';
import api from '~/services/api';
import history from '~/services/history';

export default function PaymentEditor({ location }) {
  const { state } = location;
  const { subscriptionId, action } = useParams();

  const isCreate = action.toLowerCase() === 'create';
  const item = state && location.state.item ? location.state.item : undefined;
  const chargeId =
    state && location.state.chargeId ? location.state.chargeId : undefined;
  const chargeName =
    state && location.state.chargeName ? location.state.chargeName : undefined;

  const [paidDate, setPaidDate] = useState(new Date());
  const [dateType, setDateType] = useState('text');

  if (action !== 'edit' && action !== 'create') {
    return history.goBack();
  }

  const handleSubmit = async (data, { resetForm }) => {
    try {
      if (isCreate) {
        let dataToSend = {
          ...data,
          subscription_id: subscriptionId,
        };
        if (chargeId) {
          dataToSend = { ...dataToSend, charge_id: chargeId };
        }
        await api.post(`/payment`, {
          ...dataToSend,
          subscription_id: subscriptionId,
        });
        toast.success(`Payment was successfully created.`);
      } else {
        await api.put(`/payment/${item.id}`, data);
        toast.success(`Payment was successfully updated.`);
      }
      resetForm();
      history.push({
        pathname: `/subscription/${subscriptionId}`,
      });
    } catch (err) {
      toast.error(
        err.response &&
          err.response.data &&
          err.response.data.error &&
          typeof err.response.data.error === 'string'
          ? err.response.data.error
          : `Error while ${isCreate ? 'creating' : 'editing'} the payment`
      );
    }
  };
  return (
    <Container>
      <Form onSubmit={handleSubmit} initialData={item}>
        {isCreate && (
          <>
            <GroupHeader>Payment Information{` - ${chargeName}`}</GroupHeader>
            <Group>
              <Input
                label="Total Paid"
                type="number"
                name="amount"
                step=".01"
              />
              <Select
                label="Payment Method"
                name="type"
                options={[
                  { id: 'CASH', title: 'CASH' },
                  { id: 'DEBIT_CARD', title: 'DEBIT CARD' },
                  { id: 'REFERRAL', title: 'REFERRAL' },
                  { id: 'DEBIT_CARD_SEB', title: 'DEBIT CARD (SEB)' },
                  { id: 'WIRE', title: 'WIRE' },
                  { id: 'CHECK', title: 'CHECK' },
                ]}
              />
              <Input
                label="Date"
                placeholder={
                  typeof paidDate === 'object'
                    ? paidDate.toISOString().substr(0, 10)
                    : new Date().toISOString().substr(0, 10)
                }
                type={dateType}
                onFocus={() => {
                  setDateType('date');
                }}
                onBlur={() => {
                  setDateType('text');
                }}
                name="date"
                onChange={event => {
                  const date =
                    event.target.value.trim() === ''
                      ? new Date()
                      : parseISO(event.target.value);
                  setPaidDate(date);
                }}
              />
            </Group>
          </>
        )}
        <GroupHeader>Notes</GroupHeader>
        <Group>
          <Input
            type="text"
            name="notes"
            label="Notes"
            multiline
            style={{ maxWidth: '50%' }}
          />
        </Group>
        <button type="submit">{isCreate ? 'Create' : 'Edit'}</button>
      </Form>
    </Container>
  );
}
PaymentEditor.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.shape({
      item: PropTypes.shape(),
      chargeId: PropTypes.number,
      chargeName: PropTypes.string,
    }),
  }).isRequired,
};
